<!-- an hidden div is created to set the position of appearance of the menu-->
<div
    style="visibility: hidden; position: fixed"
    [style.left]="menuTopLeftPosition.x"
    [style.top]="menuTopLeftPosition.y"
    [matMenuTriggerFor]="orgBoardMenu"
></div>

<!-- standard material menu -->
<mat-menu #orgBoardMenu="matMenu">
    <ng-template matMenuContent let-item="item">
        <button mat-menu-item *ngFor="let item of contextMenuItems" (click)="item.action()" [disabled]="item.disabled">
            <mat-icon [color]="item.colour" [style.color]="item.iconColor">{{ item.icon }}</mat-icon> {{ item.display }}
        </button>
    </ng-template>
</mat-menu>

<mat-menu #orgTasks="matMenu" class="org-tasks-menu">
    <ng-template matMenuContent let-item="item">
        @for (task of securityTasks; track $index) {
            @if (toTaskPresentation(task); as p) {
                <div mat-menu-item (click)="onSelectOrgSecurityTask(task)" class="change-item {{ p.action }}">
                    <mat-icon class="change-icon {{ p.action }}">{{ p.icon }}</mat-icon>
                    <span class="change-detail">
                        <strong>{{ p.name }}</strong>
                        <span class="change-action-label">{{ p.action }}</span>
                        <span class="change-meta">{{
                            (task.completedTimestamp?.toDate() || task.createdTimeStamp.toDate() | date: 'shortDate') ||
                                ''
                        }}</span>
                    </span>
                    <mat-icon class="status-icon" [class]="p.statusLabel">{{ p.statusIcon }}</mat-icon>
                </div>
            }
        } @empty {
            <div mat-menu-item disabled class="no-changes">
                <mat-icon>check_circle_outline</mat-icon>
                <span>No recent activity.</span>
            </div>
        }
        <div mat-menu-item (click)="onOpenOrgNotifications()" class="see-more-row">
            <mat-icon>more_horiz</mat-icon>
            <i>See more...</i>
        </div>
    </ng-template>
</mat-menu>

<!-- <div class="vh-90" [ngClass]="{'disable-mouse-events': isDragging}"> -->
<div
    #boardRoot
    class="org-board-component no-select h-100"
    [class.ob-presenting]="isPresenting"
    (contextmenu)="onRightClick($event)"
>
    <mat-progress-bar *ngIf="showLoader" color="primary" mode="indeterminate"></mat-progress-bar>
    <div class="org-board-header">
        <!-- Enable editing button. -->
        <div *ngIf="mayEdit" class="edit-controls">
            <button mat-raised-button color="accent" class="ml-5" (click)="onEditClick(true)" *ngIf="!isEditing">
                Edit <mat-icon>edit</mat-icon>
            </button>
            <button mat-raised-button color="primary" class="ml-5" (click)="onEditClick(false)" *ngIf="isEditing">
                Done <mat-icon>check</mat-icon>
            </button>
            <!-- Org name surfaced in edit mode so the editor always knows which
           org they're touching (the header dropdown gets pushed off-screen
           on small viewports). -->
            <span
                *ngIf="isEditing && organization?.name"
                class="editing-org-name"
                [matTooltip]="organization?.name || ''"
            >
                <mat-icon class="editing-org-name__icon">corporate_fare</mat-icon>
                <span class="editing-org-name__label">Editing</span>
                <span class="editing-org-name__name">{{ organization?.name }}</span>
            </span>
        </div>

        <div class="flex-spacer"></div>

        <!-- Right-aligned controls group -->
        <div class="header-right-controls">
            <!-- Full screen: the board alone, fitted to the screen width (wall TV). -->
            <button
                *ngIf="!isEditing"
                mat-stroked-button
                class="mr-3 ob-present-btn"
                data-testid="board-fullscreen"
                matTooltip="Show the board on its own, filling the screen. Esc to leave."
                (click)="togglePresenting()"
            >
                <mat-icon>fullscreen</mat-icon>
                Full screen
            </button>

            <!-- ISS-006: viewers can keep ALL VFPs visible instead of hover-hunting.
           Available outside edit mode by design — it's a reading preference. -->
            <mat-slide-toggle
                class="mr-3"
                [checked]="showAllVfps"
                (change)="onShowAllVfpsChange($event.checked)"
                matTooltip="Show every position's VFP permanently instead of only on hover"
                aria-label="Toggle always-visible VFPs"
            >
                Show VFPs
            </mat-slide-toggle>

            <mat-slide-toggle
                *ngIf="isEditing"
                class="mr-3"
                [checked]="isVfpEditingOn"
                (change)="isVfpEditingOn = $event.checked"
                matTooltip="When enabled, hovering over org parts reveals VFP (Valuable Final Product) fields for viewing and editing"
                aria-label="Toggle VFP editing"
            >
                VFP Editing
            </mat-slide-toggle>

            <!-- Edit-only: work on the STRUCTURE with every person switched off
           (design: ORG-BOARD-HIDE-STAFF-IN-EDIT-MODE-DESIGN.md). Resets on Done. -->
            <mat-slide-toggle
                *ngIf="isEditing"
                class="mr-3"
                [checked]="hideStaffOnBoard"
                (change)="onHideStaffChange($event.checked)"
                matTooltip="Hide the people on the posts while you edit the org structure (staff drag-and-drop is paused)"
                aria-label="Toggle hide staff"
            >
                Hide staff
            </mat-slide-toggle>

            <mat-slide-toggle
                *ngIf="isDev"
                class="mr-3 ob-dev-toggle"
                [checked]="isPositionsSwitchOn"
                (change)="onPositionsSwitchChange($event.checked)"
                aria-label="Toggle org parts display"
            >
                Org Parts
            </mat-slide-toggle>

            <!-- Export to Excel — admin/edit-mode only. Snapshots the org structure
           and staff assignments to an .xlsx (see OrgExcelService). -->
            <button
                *ngIf="isEditing"
                mat-icon-button
                class="mr-2"
                matTooltip="Export org board to Excel (.xlsx)"
                aria-label="Export org board to Excel"
                (click)="onExportToExcel()"
            >
                <mat-icon>file_download</mat-icon>
            </button>

            <!-- Publish-as-template (P4.c) — admin/edit-mode only. Snapshots the
           current org into `orgTemplates/`; ownership re-checked in the dialog
           and again server-side. -->
            <button
                *ngIf="isEditing"
                mat-icon-button
                class="mr-2"
                matTooltip="Publish this organization as a reusable template"
                aria-label="Publish as template"
                (click)="onPublishAsTemplate()"
            >
                <mat-icon>publish</mat-icon>
            </button>

            <button
                mat-icon-button
                class="org-activities-icon"
                [mat-menu-trigger-for]="orgTasks"
                [matBadgeHidden]="areAllSecurityTasksComplete()"
                [matBadge]="countOfIncompleteTasks()"
                matBadgeColor="accent"
            >
                <mat-icon>corporate_fare</mat-icon>
            </button>

            <!-- Hidden for now - Link type and Orientation controls
      <div *ngIf="tree?.config && !this.isEditing" [@smoothHeight] [@shrinkWidthLeave] [@delayedOpacity]
        style="display: inherit; flex-wrap: nowrap;">

        <mat-form-field>
          <mat-label>Link type</mat-label>
          <mat-select [(ngModel)]="tree.config.linkType" (ngModelChange)="updateTree()">
            <mat-option *ngFor="let opt of lineOptions" [value]="opt.value">{{opt.display}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Orientation</mat-label>
          <mat-select [(ngModel)]="tree.config.iRootOrientation"
            (ngModelChange)="tree.config.iRootOrientation=$event;updateTree()">
            <mat-option *ngFor="let opt of orientationOptions" [value]="opt.value">{{opt.display}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      -->
        </div>

        <!-- Commented out: Old toolbar-functions - now using dialog modals instead
    <div *ngIf="this.isEditing" [@smoothHeight] [@shrinkWidthLeave] [@delayedOpacity] class="toolbar-functions">

      <ng-container [ngSwitch]="toolbarSelection">
          
        <div *ngSwitchCase="'users'" class="d-flex h-100" [@smoothHeight] [@slideInOut] [@delayedOpacity] >
          <div class="toolbox">
            <mat-selection-list #userSelect>
              <mat-list-option *ngFor="let user of userOptions" [value]="user.value">
                {{user.display}}
              </mat-list-option>
            </mat-selection-list>
          </div>

          <div class="toolbox">
            <p *ngFor="let u of userSelect.selectedOptions.selected">
              {{u.value}}
            </p>
          </div>

        </div>


        <div *ngSwitchCase="'hats'" class="d-flex h-100" [@smoothHeight] [@slideInOut] [@delayedOpacity] >
        
          <div class="toolbox">
            <mat-selection-list #userSelect>
              <mat-list-option *ngFor="let user of hatOptions" [value]="user.value">
                {{user.display}}
              </mat-list-option>
            </mat-selection-list>
          </div>

          <div class="toolbox">
            <p *ngFor="let u of userSelect.selectedOptions.selected">
              {{u.value}}
            </p>
          </div>

        </div>


        <div *ngSwitchCase="'policies'" class="d-flex h-100" [@smoothHeight] [@slideInOut] [@delayedOpacity] >
        
          <div class="toolbox">
            <mat-selection-list #userSelect>
              <mat-list-option *ngFor="let user of policyOptions" [value]="user.value">
                {{user.display}}
              </mat-list-option>
            </mat-selection-list>
          </div>

          <div class="toolbox">
            <p *ngFor="let u of userSelect.selectedOptions.selected">
              {{u.value}}
            </p>
          </div>

        </div>

        <div *ngSwitchCase="'security-groups'" class="d-flex h-100" [@smoothHeight] [@slideInOut] [@delayedOpacity] >
        
          <div class="toolbox">
            <mat-selection-list #userSelect>
              <mat-list-option *ngFor="let user of securityGroupOptions" [value]="user.value">
                {{user.display}}
              </mat-list-option>
            </mat-selection-list>
          </div>

          <div class="toolbox">
            <p *ngFor="let u of userSelect.selectedOptions.selected">
              {{u.value}}
            </p>
          </div>

        </div>

        <div *ngSwitchDefault>
        </div>
      </ng-container>

    </div>
    --></div>

    <div
        class="ob-container"
        [ngClass]="{ 'justify-content-end': !isEditing }"
        [class.ob-show-all-vfps]="showAllVfps"
        [class.ob-hide-staff]="hideStaffOnBoard"
    >
        <!-- Presenting: one quiet button to leave (Esc works too). -->
        <button
            *ngIf="isPresenting"
            type="button"
            mat-mini-fab
            class="ob-present-exit"
            data-testid="board-fullscreen-exit"
            aria-label="Leave full screen"
            matTooltip="Leave full screen (Esc)"
            (click)="togglePresenting()"
        >
            <mat-icon>fullscreen_exit</mat-icon>
        </button>

        <!-- Mobile-only floating board controls. On phones the toolbar row is hidden
         (CSS) so the board gets the full height; these floats stand in for it,
         grouped top-right (Edit then activities). -->
        <div class="ob-float-controls" [class.editing]="isEditing">
            <!-- Edit-mode tools palette (mobile) → bottom sheet. -->
            <button
                *ngIf="isEditing"
                type="button"
                mat-mini-fab
                class="ob-float-btn"
                color="accent"
                (click)="openToolsSheet()"
                aria-label="Org board tools"
            >
                <mat-icon>build</mat-icon>
            </button>

            <button
                *ngIf="mayEdit"
                type="button"
                mat-mini-fab
                class="ob-float-btn"
                [color]="isEditing ? 'primary' : 'accent'"
                (click)="onEditClick(!isEditing)"
                [attr.aria-label]="isEditing ? 'Done editing' : 'Edit organization'"
            >
                <mat-icon>{{ isEditing ? 'check' : 'edit' }}</mat-icon>
            </button>

            <button
                type="button"
                mat-mini-fab
                class="ob-float-btn"
                [matMenuTriggerFor]="orgTasks"
                [matBadgeHidden]="areAllSecurityTasksComplete()"
                [matBadge]="countOfIncompleteTasks()"
                matBadgeColor="accent"
                aria-label="Organization activities"
            >
                <mat-icon>corporate_fare</mat-icon>
            </button>
        </div>

        <!-- Side toolbar. -->
        <div *ngIf="isEditing" [@smoothHeight] [@shrinkWidthLeave] [@delayedOpacity] class="ob-toolbar">
            <div class="ob-toolbar-content">
                <mat-selection-list
                    #obSideToolbar
                    [multiple]="false"
                    hideSingleSelectionIndicator="true"
                    (selectionChange)="onSelectSideToolbar($event)"
                >
                    <mat-list-option *ngIf="mayManageUsers" value="users">
                        <mat-icon matListItemIcon>account_circle</mat-icon>
                        <div matListItemTitle>Staff</div>
                        <div matListItemLine>People within the organization.</div>
                    </mat-list-option>
                    <mat-list-option *ngIf="mayManageHats" value="hats">
                        <mat-icon matListItemIcon>school</mat-icon>
                        <div matListItemTitle>Hats</div>
                        <div matListItemLine>Hats worn by people.</div>
                    </mat-list-option>
                    <mat-list-option *ngIf="mayManagePolicies && policiesModuleOn" value="policies">
                        <mat-icon matListItemIcon>policy</mat-icon>
                        <div matListItemTitle>Policies</div>
                        <div matListItemLine>Policies of the Organization.</div>
                    </mat-list-option>
                    <mat-list-option *ngIf="mayManageSecurityGroups" value="security_groups">
                        <mat-icon matListItemIcon>badge</mat-icon>
                        <div matListItemTitle>Security Groups</div>
                        <div matListItemLine>Authorization for each Hat/Staff Member.</div>
                    </mat-list-option>
                    <mat-list-option value="positions">
                        <mat-icon matListItemIcon>business</mat-icon>
                        <div matListItemTitle>Org Parts Scaffolding</div>
                        <div matListItemLine>Organization hierarchy.</div>
                    </mat-list-option>

                    <mat-divider></mat-divider>
                    <div mat-subheader>Quick Actions</div>
                    <mat-list-option *ngIf="mayManageUsers && invitationsModuleOn" value="new_user">
                        <mat-icon matListItemIcon>add</mat-icon>
                        <div matListItemTitle>Invite Staff Member</div>
                    </mat-list-option>
                    <mat-list-option *ngIf="mayManagePolicies && policiesModuleOn" value="new_policy">
                        <mat-icon matListItemIcon>add</mat-icon>
                        <div matListItemTitle>New Policy</div>
                    </mat-list-option>
                    <mat-list-option *ngIf="mayManageHats" value="new_hat">
                        <mat-icon matListItemIcon>add</mat-icon>
                        <div matListItemTitle>New Hat</div>
                    </mat-list-option>
                    <mat-list-option *ngIf="newOrgPartOn" value="new_part">
                        <mat-icon matListItemIcon>add</mat-icon>
                        <div matListItemTitle>New Org Part</div>
                    </mat-list-option>
                    <mat-list-option *ngIf="mayManageSecurityGroups" value="new_sg">
                        <mat-icon matListItemIcon>add</mat-icon>
                        <div matListItemTitle>New Security Group</div>
                    </mat-list-option>
                </mat-selection-list>
            </div>
        </div>

        <!-- <div style="height: auto; position: absolute; width: calc(100% - 1px); left: 0;"> -->
        <!-- [ngClass]="{'drag-without-toolbar': !isEditing, 'drag-with-toolbar': isEditing}"  -->
        <div
            class="drag-container"
            #dragContainer
            [class.ob-touch-nav]="isTouchDevice"
            [class.ob-touch]="isTouchDevice"
            [ngStyle]="{ width: orgBoardWidth }"
            id="dragScroll"
            (wheel)="onBoardWheel($event)"
        >
            <!-- ISS-019: column labels once their headers scroll away (drawn by updateBoardPlace) -->
            <div class="ob-place-anchor"><div class="ob-place-layer" #placeLayer></div></div>
            <ng-container *ngIf="organization; else infoTemplate">
                <drag-scroll
                    class="min-h-300 hover-hand"
                    (dragStart)="onDragNavStart()"
                    (dragEnd)="onDragNavEnd()"
                    [drag-scroll-disabled]="isDragNavDisabled"
                >
                    <!-- Adjust as required. Just bare in mind all instances of the tree will be affected.
              This max height will allow the tree to be scrollable within the drag-scroll container.  -->
                    <!-- <section drag-scroll-item id="adminTreeView" style="max-height: 80vh;"> -->
                    <section id="adminTreeView" style="min-width: 100%; max-height: 100%">
                        <div
                            class="tree"
                            [class.drag-active]="isDroppableItemBeingDragged"
                            id="dragScrollTree"
                            *ngIf="tree.width && tree.height"
                            [style.padding]="treePaddingScaled()"
                            [style.width]="treeWidthScaled()"
                            [style.height]="treeHeightScaled()"
                        >
                            <div
                                class="scroll-hover-region left"
                                *ngIf="isDroppableItemBeingDragged"
                                (touchstart)="scrollHorizontal(5)"
                                (touchend)="stopInterval()"
                                (touchcancel)="stopInterval()"
                                (touchmove)="scrollHorizontal(5)"
                                (mouseover)="scrollHorizontal(5)"
                                (mouseleave)="stopInterval()"
                            ></div>
                            <div
                                class="scroll-hover-region top"
                                *ngIf="isDroppableItemBeingDragged"
                                (touchstart)="scrollVertical(5)"
                                (touchend)="stopInterval()"
                                (touchcancel)="stopInterval()"
                                (touchmove)="scrollVertical(5)"
                                (mouseover)="scrollVertical(5)"
                                (mouseleave)="stopInterval()"
                            ></div>

                            <!-- cdkDropListGroup -->
                            <div class="wrapper" cdkDropListGroup [style.transform]="'scale(' + zoomLevel + ')'">
                                <svg
                                    class="treeLink"
                                    [style.width]="tree.width + 'px'"
                                    [style.height]="tree.height + 'px'"
                                >
                                    <path
                                        *ngFor="let path of childrenLinkPaths"
                                        [attr.stroke]="path.stroke"
                                        [attr.d]="path.d"
                                    />
                                    <!-- Cosmetic connectors for detached groups (Board of Directors).
                       Dashed to read as a non-structural / governance link, and
                       pointer-events:none so they NEVER win elementFromPoint over
                       the chips during a drag. -->
                                    <path
                                        *ngFor="let path of detachedLinkPaths"
                                        class="detached-link"
                                        [attr.stroke]="path.stroke"
                                        [attr.d]="path.d"
                                    />
                                </svg>

                                <!-- ECO Tree Node Rendering Loop
                     Each node is absolutely positioned on the canvas at (XPosition, YPosition).
                     Height flows: .node-wrapper [node.h] → .draggable-item [node.h, flex-column]
                       → .above-card (fixed header) + <section> [flex:1, fills rest]
                       → shared-org-board-node [height:100%] → mat-card [height:100%]
                     See: updateNodeDimensions() and organization-board.component.scss for full docs. -->
                                <ng-container
                                    *ngFor="let node of tree.nDatabaseNodes; let i = index; trackBy: trackByNodeId"
                                >
                                    <div
                                        class="node-wrapper"
                                        [class.deleting-part]="isPartBeingDeleted(node?.data?.partKey)"
                                        [ngStyle]="{
                                            height: node.h + 'px',
                                            width: node.w + 'px',
                                            left: node.XPosition + 'px',
                                            top: node.YPosition + 'px',
                                            position: 'absolute',
                                        }"
                                    >
                                        <!-- {{node.h}} -->

                                        <div
                                            *ngIf="!node._isAncestorCollapsed()"
                                            class="draggable-item"
                                            [ngStyle]="{
                                                height: node.h + 'px',
                                                width: node.w + 'px',
                                            }"
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    treeTemplate ? treeTemplate : defaultTemplate;
                                                    context: { $implicit: node }
                                                "
                                            >
                                            </ng-container>
                                        </div>
                                    </div>
                                </ng-container>

                                <!-- ════════════════════════════════════════════════════════════
                     Detached post-group boxes (e.g. Board of Directors).
                     Absolutely positioned inside .wrapper so they inherit the
                     board's scale() transform (pan/zoom track for free). The
                     chips carry the SAME droppable-part attr set as the header
                     strip, so a pool-user drop resolves to the real post via the
                     onUserPoolDragEnd → elementFromPoint fallback — identical to
                     dropping inside the owning container.
                     ════════════════════════════════════════════════════════════ -->
                                <div
                                    *ngFor="let box of detachedBoxes; let i = index"
                                    class="ob-detached-box"
                                    [attr.data-detached-idx]="i"
                                    [ngStyle]="{
                                        left: box.left + 'px',
                                        top: box.top + 'px',
                                        width: box.width + 'px',
                                        position: 'absolute',
                                    }"
                                >
                                    <div class="ob-detached-box-title">
                                        {{ box.title }}
                                        <!-- Structure menu, edit mode only (stays with Hide staff on). -->
                                        <button
                                            *ngIf="isEditing && box.ownerNode"
                                            mat-icon-button
                                            class="ob-detached-box-menu-btn"
                                            [matMenuTriggerFor]="detachedBoxMenu"
                                            [matMenuTriggerData]="{ box: box }"
                                            aria-label="Board of Directors menu"
                                            (click)="$event.stopPropagation()"
                                        >
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                    </div>
                                    <div class="ob-detached-box-posts">
                                        <span
                                            *ngFor="let p of box.posts"
                                            class="ob-header-post-chip clickable-span droppable-part"
                                            [attr.data-part-key]="p?.partKey || p?.key"
                                            [attr.data-part-type]="'post'"
                                            [attr.data-part-name]="p?.name"
                                            [attr.data-parent-dept-key]="box.parentDeptKey"
                                            (click)="
                                                onOpenPositionTemplate({ data: p, parentNode: null });
                                                $event.stopPropagation()
                                            "
                                            style="
                                                position: relative;
                                                display: flex;
                                                align-items: center;
                                                gap: 12px;
                                                padding: 10px 14px;
                                                border-radius: 14px;
                                                background: rgba(255, 255, 255, 0.97);
                                                color: #222;
                                                border: 1px solid rgba(0, 0, 0, 0.12);
                                                line-height: 1.3;
                                                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
                                                cursor: pointer;
                                                width: 100%;
                                                box-sizing: border-box;
                                            "
                                        >
                                            <!-- Render EVERY occupant (active first, then pending) so an
                           approval-pending director is visible with a badge — a
                           Board post legitimately holds multiple people. -->
                                            <span
                                                style="
                                                    display: flex;
                                                    flex-direction: column;
                                                    gap: 8px;
                                                    width: 100%;
                                                    text-align: left;
                                                    padding-right: 28px;
                                                "
                                            >
                                                <span
                                                    style="
                                                        font-size: 19px;
                                                        font-weight: 700;
                                                        color: #333;
                                                        word-break: break-word;
                                                        overflow-wrap: anywhere;
                                                    "
                                                    >{{ p?.name }}</span
                                                >
                                                <ng-container *ngIf="visibleDetachedOccupants(p) as occ">
                                                    <span
                                                        *ngFor="let u of occ"
                                                        class="ob-staff"
                                                        style="display: flex; align-items: center; gap: 10px"
                                                    >
                                                        <span
                                                            style="
                                                                position: relative;
                                                                flex-shrink: 0;
                                                                width: 48px;
                                                                height: 48px;
                                                            "
                                                        >
                                                            <img
                                                                [src]="getUserAvatarUrl(u)"
                                                                alt=""
                                                                [style.filter]="
                                                                    u?.isPending ? 'grayscale(0.4)' : 'none'
                                                                "
                                                                style="
                                                                    width: 48px;
                                                                    height: 48px;
                                                                    border-radius: 50%;
                                                                    object-fit: cover;
                                                                    display: block;
                                                                "
                                                            />
                                                            <span
                                                                *ngIf="isHeaderUserOnline(u)"
                                                                title="Online"
                                                                style="
                                                                    position: absolute;
                                                                    top: -3px;
                                                                    right: -3px;
                                                                    width: 12px;
                                                                    height: 12px;
                                                                    border-radius: 50%;
                                                                    background-color: #2ecc71;
                                                                    border: 2px solid white;
                                                                    pointer-events: none;
                                                                "
                                                            ></span>
                                                        </span>
                                                        <span
                                                            style="
                                                                display: flex;
                                                                flex-direction: column;
                                                                min-width: 0;
                                                                flex: 1;
                                                            "
                                                        >
                                                            <span
                                                                style="
                                                                    font-weight: 500;
                                                                    font-size: 28px;
                                                                    color: #111;
                                                                    white-space: nowrap;
                                                                    overflow: hidden;
                                                                    text-overflow: ellipsis;
                                                                "
                                                                >{{ u?.name }}</span
                                                            >
                                                            <span
                                                                *ngIf="u?.isPending && !u?.awaitingAcceptance"
                                                                matTooltip="Awaiting admin approval"
                                                                style="
                                                                    align-self: flex-start;
                                                                    margin-top: 1px;
                                                                    font-size: 10px;
                                                                    font-weight: 700;
                                                                    text-transform: uppercase;
                                                                    letter-spacing: 0.4px;
                                                                    color: #8a5a00;
                                                                    background: #fff3e0;
                                                                    border: 1px solid #f0ad4e;
                                                                    border-radius: 6px;
                                                                    padding: 0 6px;
                                                                "
                                                                >Pending approval</span
                                                            >
                                                            <span
                                                                *ngIf="u?.awaitingAcceptance"
                                                                matTooltip="Invited — awaiting the user to accept their org invitation; cannot approve until then"
                                                                style="
                                                                    align-self: flex-start;
                                                                    margin-top: 1px;
                                                                    font-size: 10px;
                                                                    font-weight: 700;
                                                                    text-transform: uppercase;
                                                                    letter-spacing: 0.4px;
                                                                    color: #555;
                                                                    background: #eceff1;
                                                                    border: 1px solid #b0bec5;
                                                                    border-radius: 6px;
                                                                    padding: 0 6px;
                                                                "
                                                                >Invited</span
                                                            >
                                                        </span>
                                                        <!-- Approve (only for pending-approval, not awaiting-acceptance) + decline/remove — edit mode only, mirroring the board nodes. -->
                                                        <button
                                                            *ngIf="isEditing && u?.isPending && !u?.awaitingAcceptance"
                                                            mat-icon-button
                                                            matTooltip="Approve assignment"
                                                            style="
                                                                width: 26px;
                                                                height: 26px;
                                                                line-height: 26px;
                                                                min-width: 26px;
                                                                padding: 0;
                                                                background-color: #2e7d32;
                                                                border-radius: 50%;
                                                                flex-shrink: 0;
                                                            "
                                                            (click)="
                                                                onApproveUser({
                                                                    user: u,
                                                                    node: box.ownerNode,
                                                                    post: p,
                                                                });
                                                                $event.stopPropagation()
                                                            "
                                                        >
                                                            <mat-icon
                                                                style="
                                                                    font-size: 16px;
                                                                    width: 16px;
                                                                    height: 16px;
                                                                    color: white;
                                                                "
                                                                >check</mat-icon
                                                            >
                                                        </button>
                                                        <button
                                                            *ngIf="isEditing"
                                                            mat-icon-button
                                                            [matTooltip]="
                                                                u?.isPending
                                                                    ? 'Decline pending assignment'
                                                                    : 'Remove from Board'
                                                            "
                                                            style="
                                                                width: 26px;
                                                                height: 26px;
                                                                line-height: 26px;
                                                                min-width: 26px;
                                                                padding: 0;
                                                                background-color: #c62828;
                                                                border-radius: 50%;
                                                                flex-shrink: 0;
                                                            "
                                                            (click)="
                                                                onRemoveUserFromPosition({
                                                                    userId: u?.uid || u?.key,
                                                                    partKey: p?.partKey || p?.key,
                                                                });
                                                                $event.stopPropagation()
                                                            "
                                                        >
                                                            <mat-icon
                                                                style="
                                                                    font-size: 16px;
                                                                    width: 16px;
                                                                    height: 16px;
                                                                    color: white;
                                                                "
                                                                >{{ u?.isPending ? 'close' : 'remove' }}</mat-icon
                                                            >
                                                        </button>
                                                    </span>
                                                    <span
                                                        *ngIf="!occ.length"
                                                        class="ob-staff"
                                                        style="
                                                            margin-top: 2px;
                                                            font-style: italic;
                                                            font-weight: 500;
                                                            font-size: 13px;
                                                            color: #888;
                                                        "
                                                        >Unoccupied</span
                                                    >
                                                </ng-container>
                                                <span
                                                    *ngIf="p?.vfp"
                                                    class="sub-part-vfp"
                                                    [class.vfp-pinned]="p?.vfpAlwaysVisible"
                                                    style="
                                                        font-size: 13px;
                                                        line-height: 1.35;
                                                        color: #444;
                                                        white-space: pre-wrap;
                                                        word-break: break-word;
                                                        text-align: left;
                                                    "
                                                >
                                                    <strong>VFP:</strong> {{ p.vfp }}
                                                </span>
                                            </span>
                                        </span>
                                    </div>
                                </div>

                                <!-- Division VFP boxes - span across child departments -->
                                <ng-container *ngFor="let box of getDivisionVfpBoxes(); trackBy: trackDivisionVfpBox">
                                    <div
                                        class="division-vfp-box"
                                        [ngStyle]="{
                                            position: 'absolute',
                                            left: box.left + 'px',
                                            top: box.top + 'px',
                                            width: box.width + 'px',
                                            'min-height': '40px',
                                            'background-color': '#777',
                                            'border-radius': '6px',
                                            padding: '10px 14px',
                                            'box-sizing': 'border-box',
                                            color: '#eee',
                                            'z-index': '5',
                                            display: 'flex',
                                            'align-items': 'stretch',
                                            gap: '12px',
                                        }"
                                        (click)="
                                            isEditing && !editingDivisionVfp[box.partKey]
                                                ? startEditingDivisionVfp(box.partKey)
                                                : null;
                                            $event.stopPropagation()
                                        "
                                        [style.cursor]="isEditing ? 'pointer' : 'default'"
                                    >
                                        <div
                                            style="
                                                display: flex;
                                                flex-direction: column;
                                                align-items: center;
                                                gap: 2px;
                                                padding-right: 4px;
                                                min-width: 36px;
                                            "
                                        >
                                            <mat-icon style="font-size: 28px; width: 28px; height: 28px; opacity: 0.9"
                                                >emoji_events</mat-icon
                                            >
                                            <div
                                                style="
                                                    font-size: 9px;
                                                    text-transform: uppercase;
                                                    letter-spacing: 0.5px;
                                                    font-weight: 700;
                                                "
                                            >
                                                VFP
                                            </div>
                                        </div>
                                        <div style="flex: 1; min-width: 0">
                                            <!-- View mode -->
                                            <div
                                                *ngIf="!editingDivisionVfp[box.partKey]"
                                                style="
                                                    font-size: 13px;
                                                    line-height: 1.4;
                                                    font-weight: 700;
                                                    word-wrap: break-word;
                                                    overflow-wrap: break-word;
                                                "
                                                [style.font-style]="box.vfp ? 'normal' : 'italic'"
                                                [style.opacity]="box.vfp ? '1' : '0.6'"
                                            >
                                                {{ box.vfp || (isEditing ? 'Click to add VFP...' : '') }}
                                            </div>
                                            <!-- Edit mode -->
                                            <div *ngIf="editingDivisionVfp[box.partKey]" style="width: 100%">
                                                <textarea
                                                    #divVfpTextarea
                                                    style="
                                                        width: 100%;
                                                        min-height: 60px;
                                                        background: rgba(0, 0, 0, 0.25);
                                                        border: 1px solid rgba(255, 255, 255, 0.3);
                                                        border-radius: 4px;
                                                        color: #eee;
                                                        font-size: 13px;
                                                        padding: 8px;
                                                        resize: vertical;
                                                        font-family: inherit;
                                                        box-sizing: border-box;
                                                        font-weight: 700;
                                                    "
                                                    [value]="box.vfp"
                                                    (blur)="onDivisionVfpBlur(box.partKey, divVfpTextarea.value)"
                                                    (keydown)="
                                                        onDivisionVfpKeydown($event, box.partKey, divVfpTextarea)
                                                    "
                                                    placeholder="Describe the Valuable Final Product of this division..."
                                                ></textarea>
                                                <div style="font-size: 11px; opacity: 0.5; margin-top: 2px">
                                                    Ctrl+Enter to save, Esc to cancel, click away to save
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>

                            <div
                                class="scroll-hover-region bottom"
                                *ngIf="isDroppableItemBeingDragged"
                                (touchstart)="scrollVertical(-5)"
                                (touchend)="stopInterval()"
                                (touchcancel)="stopInterval()"
                                (touchmove)="scrollVertical(-5)"
                                (mouseover)="scrollVertical(-5)"
                                (mouseleave)="stopInterval()"
                            ></div>
                            <div
                                class="scroll-hover-region right"
                                *ngIf="isDroppableItemBeingDragged"
                                (touchstart)="scrollHorizontal(-5)"
                                (touchend)="stopInterval()"
                                (touchcancel)="stopInterval()"
                                (touchmove)="scrollHorizontal(-5)"
                                (mouseover)="scrollHorizontal(-5)"
                                (mouseleave)="stopInterval()"
                            ></div>
                        </div>
                    </section>

                    <ng-template #defaultTemplate let-node>
                        <div class="item" [ngStyle]="{ 'background-color': node.bc, color: node.c }">
                            {{ node.id }}
                        </div>
                    </ng-template>
                </drag-scroll>

                <!-- Zoom controls for board. -->
                <div class="zoom-controls" [ngClass]="{ 'm-0': isEditing }">
                    <button mat-icon-button (click)="zoomIn(); $event.stopPropagation()">
                        <mat-icon>zoom_in</mat-icon>
                    </button>
                    <button mat-icon-button (click)="zoomOut(); $event.stopPropagation()">
                        <mat-icon>zoom_out</mat-icon>
                    </button>

                    <button
                        mat-icon-button
                        matTooltip="Fit the board to the screen width"
                        aria-label="Fit the board to the screen width"
                        (click)="fitBoardToScreen(); $event.stopPropagation()"
                    >
                        <mat-icon>fit_screen</mat-icon>
                    </button>

                    <button mat-icon-button (click)="resetZoom(); $event.stopPropagation()">
                        <mat-icon>zoom_out_map</mat-icon>
                    </button>

                    <div class="d-flex">
                        <mat-slider
                            style="flex: 1 auto"
                            [max]="2.5"
                            [min]="0.15"
                            [step]="0.001"
                            [discrete]="false"
                            [showTickMarks]="false"
                        >
                            <input matSliderThumb [(ngModel)]="zoomLevel" />
                        </mat-slider>
                    </div>
                </div>
            </ng-container>

            <ng-template #infoTemplate>
                <p>Select an organization to view the organization board.</p>
            </ng-template>
        </div>
    </div>

    <!-- User Pool Drawer (Right side) - Only visible in edit mode -->
    <shared-user-pool-drawer
        *ngIf="isEditing && !hideStaffOnBoard"
        [organization]="organization"
        [isEditing]="isEditing"
        [connectedDropLists]="dropLists"
        (userDragStarted)="onUserPoolDragStart($event)"
        (userDragEnded)="onUserPoolDragEnd($event)"
        (drawerToggled)="onUserPoolDrawerToggled($event)"
        (userDroppedOnPosition)="onUserDroppedOnPosition($event)"
        (userRemovedFromPosition)="onUserRemovedFromPosition($event)"
        (poolDropListReady)="onPoolDropListReady($event)"
    >
    </shared-user-pool-drawer>

    <!-- Delete Processing Panel (Right side) -->
    <div *ngIf="deletePanel.visible" class="delete-processing-panel">
        <div class="delete-panel-header">
            <mat-icon color="warn">delete</mat-icon>
            <span class="delete-panel-title">Deleting {{ deletePanel.partType }}</span>
            <button mat-icon-button (click)="closeDeletePanel()" matTooltip="Close">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="delete-panel-target">
            <strong>{{ deletePanel.partName }}</strong>
            <span *ngIf="deletePanel.descendantKeys.length > 0" class="delete-descendants-count">
                + {{ deletePanel.descendantKeys.length }} descendant{{
                    deletePanel.descendantKeys.length !== 1 ? 's' : ''
                }}
            </span>
        </div>

        <div class="delete-panel-body">
            <ng-container *ngIf="deletePanel.phase === 'deleting'">
                <div class="delete-panel-status">
                    <mat-spinner diameter="20"></mat-spinner>
                    <span>Sending delete request...</span>
                </div>
            </ng-container>

            <ng-container *ngIf="deletePanel.phase === 'processing' || deletePanel.phase === 'done'">
                <div *ngFor="let task of deletePanel.taskStatuses; trackBy: trackByKey" class="delete-task-item">
                    <mat-icon class="delete-task-icon" [ngClass]="task.action">{{ task.icon }}</mat-icon>
                    <span class="delete-task-detail">
                        <strong>{{ task.name }}</strong>
                        <span class="delete-task-action">{{ task.action }}</span>
                    </span>
                    <mat-icon class="delete-task-status" [ngClass]="task.status">{{ task.statusIcon }}</mat-icon>
                </div>
                <div *ngIf="deletePanel.taskStatuses.length === 0" class="delete-panel-status">
                    <mat-spinner diameter="20"></mat-spinner>
                    <span>Waiting for tasks...</span>
                </div>
            </ng-container>

            <ng-container *ngIf="deletePanel.phase === 'error'">
                <div class="delete-panel-status error">
                    <mat-icon>error</mat-icon>
                    <span>Delete failed. Please try again.</span>
                </div>
            </ng-container>
        </div>

        <!-- Progress bar -->
        <div *ngIf="deletePanel.phase === 'processing'" class="delete-panel-progress">
            <mat-progress-bar
                mode="determinate"
                [value]="deletePanel.totalTasks > 0 ? (deletePanel.tasksCompleted / deletePanel.totalTasks) * 100 : 0"
            >
            </mat-progress-bar>
            <span>Processing... {{ deletePanel.tasksCompleted }} / {{ deletePanel.totalTasks }}</span>
        </div>
        <div *ngIf="deletePanel.phase === 'done'" class="delete-panel-progress done">
            <mat-icon>check_circle</mat-icon>
            <span>All tasks completed!</span>
        </div>
    </div>

    <!-- User Operation Processing Panel (Right side) -->
    <div *ngIf="userOpPanel.visible" class="user-op-processing-panel">
        <div class="user-op-panel-header">
            <mat-icon
                [color]="userOpPanel.action === 'approve' || userOpPanel.action === 'assign' ? 'primary' : 'warn'"
            >
                {{
                    userOpPanel.action === 'approve'
                        ? 'check_circle'
                        : userOpPanel.action === 'assign'
                          ? 'person_add'
                          : 'person_remove'
                }}
            </mat-icon>
            <span class="user-op-panel-title">
                {{
                    userOpPanel.action === 'approve'
                        ? 'Approving User'
                        : userOpPanel.action === 'assign'
                          ? 'Assigning User'
                          : 'Removing User'
                }}
            </span>
            <button mat-icon-button (click)="closeUserOpPanel()" matTooltip="Close">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="user-op-panel-target">
            <strong>{{ userOpPanel.userName }}</strong>
            <span class="user-op-action-label">
                {{
                    userOpPanel.action === 'approve'
                        ? 'Approving assignment'
                        : userOpPanel.action === 'assign'
                          ? 'Assigning to position'
                          : userOpPanel.action === 'reject'
                            ? 'Rejecting pending assignment'
                            : 'Removing from position'
                }}
            </span>
        </div>

        <div class="user-op-panel-body">
            <ng-container *ngIf="userOpPanel.phase === 'processing'">
                <div *ngFor="let task of userOpPanel.taskStatuses; trackBy: trackByKey" class="user-op-task-item">
                    <mat-icon class="user-op-task-icon" [ngClass]="task.action">{{ task.icon }}</mat-icon>
                    <span class="user-op-task-detail">
                        <strong>{{ task.name }}</strong>
                        <span class="user-op-task-action">{{ task.action }}</span>
                    </span>
                    <mat-icon class="user-op-task-status" [ngClass]="task.status">{{ task.statusIcon }}</mat-icon>
                </div>
                <div *ngIf="userOpPanel.taskStatuses.length === 0" class="user-op-panel-status">
                    <mat-spinner diameter="20"></mat-spinner>
                    <span>Waiting for tasks...</span>
                </div>
            </ng-container>

            <ng-container *ngIf="userOpPanel.phase === 'done'">
                <div *ngFor="let task of userOpPanel.taskStatuses; trackBy: trackByKey" class="user-op-task-item">
                    <mat-icon class="user-op-task-icon" [ngClass]="task.action">{{ task.icon }}</mat-icon>
                    <span class="user-op-task-detail">
                        <strong>{{ task.name }}</strong>
                        <span class="user-op-task-action">{{ task.action }}</span>
                    </span>
                    <mat-icon class="user-op-task-status" [ngClass]="task.status">{{ task.statusIcon }}</mat-icon>
                </div>
            </ng-container>

            <ng-container *ngIf="userOpPanel.phase === 'error'">
                <div class="user-op-panel-status error">
                    <mat-icon>error</mat-icon>
                    <span>Operation failed. Please try again.</span>
                </div>
            </ng-container>
        </div>

        <!-- Progress bar -->
        <div *ngIf="userOpPanel.phase === 'processing'" class="user-op-panel-progress">
            <mat-progress-bar
                mode="determinate"
                [value]="userOpPanel.totalTasks > 0 ? (userOpPanel.tasksCompleted / userOpPanel.totalTasks) * 100 : 0"
            >
            </mat-progress-bar>
            <span>Processing... {{ userOpPanel.tasksCompleted }} / {{ userOpPanel.totalTasks }}</span>
        </div>
        <div *ngIf="userOpPanel.phase === 'done'" class="user-op-panel-progress done">
            <mat-icon>check_circle</mat-icon>
            <span>{{
                userOpPanel.action === 'approve'
                    ? 'User approved!'
                    : userOpPanel.action === 'assign'
                      ? 'User assigned!'
                      : 'User removed!'
            }}</span>
        </div>
    </div>
</div>

<!-- Template for each position on the org. -->
<ng-template #treeTemplate let-node>
    <!-- Minimize / Maximize toggle icon -->

    <!-- Department / Section / Unit / Post Header (not division) -->
    <!-- node.aboveCardMinH (set by updateNodeDimensions()) equalises the band height
       across same-type sibling cards so all departments/executives in the chart
       share the SAME header band height — same approach as body equalisation. -->
    <div
        *ngIf="node.data.partType !== 'division'"
        class="above-card"
        [ngStyle]="{ 'background-color': node.bc, color: node.c }"
        [style.min-height.px]="node.aboveCardMinH"
        [ngClass]="{ collapsable: node?.canCollapse }"
        (click)="onPositionHeaderClick(node); $event.stopPropagation()"
    >
        <div
            class="org-position-toggle"
            *ngIf="node.canCollapse"
            (mousedown)="toggleNodeCollapse(node); $event.stopPropagation()"
        >
            <mat-icon style="margin-left: 12px">{{ node.isCollapsed ? 'add' : 'remove' }}</mat-icon>
        </div>
        <!-- <span>{{node.id}}</span> -->
        <b>{{ node.data.name }}</b>
        <div style="font-size: 1.3rem; font-weight: 600">
            {{ node.data.subTitle }}
            <!-- This is the name of the position. -->
        </div>

        <!-- Department 3-dot menu (only in edit mode and for department type) -->
        <button
            *ngIf="isEditing && node.data.partType === 'department'"
            mat-icon-button
            class="org-header-menu-btn"
            [matMenuTriggerFor]="departmentMenu"
            [disabled]="isPartBeingDeleted(node?.data?.partKey)"
            (click)="$event.stopPropagation()"
        >
            <mat-icon>more_vert</mat-icon>
        </button>

        <!-- Department Menu — trialing a simplified shape: Edit takes the slot of
         the old "Manage Structure" submenu trigger. The trigger is kept
         commented inline so it can be flipped back on quickly. -->
        <mat-menu #departmentMenu="matMenu">
            <!-- Simplified menu (Paul's call, re-confirmed 2026-07-22): no "Manage
                 Structure" submenu — Edit opens the structure editor which covers
                 add/move/reorder. Trigger kept commented for easy restore.
            <button mat-menu-item [matMenuTriggerFor]="departmentStructureMenu">
                <mat-icon>account_tree</mat-icon>
                <span>Manage Structure</span>
            </button>
            -->
            <button mat-menu-item (click)="onEditDepartment(node)">
                <mat-icon>edit</mat-icon>
                <span>Edit Department</span>
            </button>
            <button mat-menu-item *ngIf="!hideStaffOnBoard" (click)="onBulkAssignStaff(node)">
                <mat-icon color="primary">group_add</mat-icon>
                <span>Assign Staff to Posts</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="onDeleteDepartment(node)">
                <mat-icon color="warn">delete</mat-icon>
                <span>Delete Department</span>
            </button>
        </mat-menu>
        <!-- Old Manage Structure submenu kept commented for easy restore:
        <mat-menu #departmentStructureMenu="matMenu">
            <button mat-menu-item (click)="onAddSiblingDepartment(node)">
                <mat-icon color="primary">add</mat-icon>
                <span>Add Sibling Department</span>
            </button>
            <button mat-menu-item (click)="onAddChildSection(node)">
                <mat-icon color="accent">add_circle</mat-icon>
                <span>Add Child Section</span>
            </button>
            <button mat-menu-item (click)="onAddChildUnitFromDept(node)">
                <mat-icon color="accent">add_circle</mat-icon>
                <span>Add Child Unit</span>
            </button>
            <button mat-menu-item (click)="onAddChildPostFromNode(node)">
                <mat-icon color="accent">add_circle</mat-icon>
                <span>Add Child Post</span>
            </button>
            <button mat-menu-item *ngIf="hasChildren(node)" (click)="onReorderDepartmentChildren(node)">
                <mat-icon>swap_vert</mat-icon>
                <span>Reorder Children</span>
            </button>
        </mat-menu>
        -->

        <!-- Executive 3-dot menu (only in edit mode and for executive type) -->
        <button
            *ngIf="isEditing && node.data.partType === 'executive'"
            mat-icon-button
            class="org-header-menu-btn"
            [matMenuTriggerFor]="executiveMenu"
            [disabled]="isPartBeingDeleted(node?.data?.partKey)"
            (click)="$event.stopPropagation()"
        >
            <mat-icon>more_vert</mat-icon>
        </button>

        <!-- Executive Menu — trialing simplified shape (see departmentMenu above
         for rationale). -->
        <mat-menu #executiveMenu="matMenu">
            <!-- Simplified menu (see departmentMenu note).
            <button mat-menu-item [matMenuTriggerFor]="executiveStructureMenu">
                <mat-icon>account_tree</mat-icon>
                <span>Manage Structure</span>
            </button>
            -->
            <button mat-menu-item (click)="onEditExecutive(node)">
                <mat-icon>edit</mat-icon>
                <span>Edit Executive</span>
            </button>
            <button mat-menu-item *ngIf="!hideStaffOnBoard" (click)="onBulkAssignStaff(node)">
                <mat-icon color="primary">group_add</mat-icon>
                <span>Assign Staff to Posts</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="onDeleteExecutive(node)">
                <mat-icon color="warn">delete</mat-icon>
                <span>Delete Executive</span>
            </button>
        </mat-menu>
        <!-- Old Manage Structure submenu kept commented for easy restore:
        <mat-menu #executiveStructureMenu="matMenu">
            <button mat-menu-item (click)="onAddSiblingExecutive(node)" *ngIf="node.data?.parentPartKey">
                <mat-icon color="primary">add</mat-icon>
                <span>Add Sibling Executive</span>
            </button>
            <button mat-menu-item (click)="onAddChildDivision(node)">
                <mat-icon color="accent">add_circle</mat-icon>
                <span>Add Child Division</span>
            </button>
            <button mat-menu-item *ngIf="hasChildren(node)" (click)="onReorderExecutiveChildren(node)">
                <mat-icon>swap_vert</mat-icon>
                <span>Reorder Children</span>
            </button>
        </mat-menu>
        -->

        <!-- Header-strip posts (head/deputy/assistant) rendered INSIDE the coloured department/executive header band -->
        <ng-container *ngIf="node.data?.headerPostsInParent?.length">
            <ng-container *ngTemplateOutlet="headerStripTpl; context: { $implicit: node }"></ng-container>
        </ng-container>

        <!-- {{ node.data | json }} -->
    </div>

    <!-- Division Header (partType === 'division') -->
    <!-- node.aboveCardMinH (set by updateNodeDimensions()) equalises the band height
       across all division headers so they share the SAME band height. -->
    <div
        *ngIf="node.data.partType === 'division'"
        class="above-card2"
        [ngStyle]="{ 'background-color': node.bc, color: node.c }"
        [style.min-height.px]="node.aboveCardMinH"
        [ngClass]="{ collapsable: node?.canCollapse }"
        (click)="onPositionHeaderClick(node); $event.stopPropagation()"
    >
        <div
            class="org-position-toggle"
            *ngIf="node.canCollapse"
            (mousedown)="toggleNodeCollapse(node); $event.stopPropagation()"
        >
            <mat-icon style="margin-left: 12px">{{ node.isCollapsed ? 'add' : 'remove' }}</mat-icon>
        </div>
        <!-- <span>{{node.id}}</span> {{node.data.name }} ****** -->
        <div style="font-size: 2.4rem; line-height: 1.15; padding-bottom: 0.5rem">
            <b>{{ node.data.mainTitle }}</b>
        </div>
        <span style="font-size: 1.8rem; font-weight: 400">
            <b>{{ node.data.name }}</b>
        </span>

        <!-- Division 3-dot menu (only in edit mode) -->
        <button
            *ngIf="isEditing"
            mat-icon-button
            class="org-header-menu-btn"
            [matMenuTriggerFor]="divisionMenu"
            [disabled]="isPartBeingDeleted(node?.data?.partKey)"
            (click)="$event.stopPropagation()"
        >
            <mat-icon>more_vert</mat-icon>
        </button>

        <!-- Division Menu — trialing simplified shape (see departmentMenu above
         for rationale). -->
        <mat-menu #divisionMenu="matMenu">
            <!-- Simplified menu (see departmentMenu note).
            <button mat-menu-item [matMenuTriggerFor]="divisionStructureMenu">
                <mat-icon>account_tree</mat-icon>
                <span>Manage Structure</span>
            </button>
            -->
            <button mat-menu-item (click)="onEditDivision(node)">
                <mat-icon>edit</mat-icon>
                <span>Edit Division</span>
            </button>
            <button mat-menu-item *ngIf="!hideStaffOnBoard" (click)="onBulkAssignStaff(node)">
                <mat-icon color="primary">group_add</mat-icon>
                <span>Assign Staff to Posts</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="onDeleteDivision(node)">
                <mat-icon color="warn">delete</mat-icon>
                <span>Delete Division</span>
            </button>
        </mat-menu>
        <!-- Old Manage Structure submenu kept commented for easy restore:
        <mat-menu #divisionStructureMenu="matMenu">
            <button mat-menu-item (click)="onAddSiblingDivision(node)">
                <mat-icon color="primary">add</mat-icon>
                <span>Add Sibling Division</span>
            </button>
            <button mat-menu-item (click)="onAddChildDepartment(node)">
                <mat-icon color="accent">add_circle</mat-icon>
                <span>Add Child Department</span>
            </button>
            <button mat-menu-item (click)="onAddChildPostFromNode(node)">
                <mat-icon color="accent">add_circle</mat-icon>
                <span>Add Child Post</span>
            </button>
            <button mat-menu-item *ngIf="hasChildren(node)" (click)="onReorderDivisionChildren(node)">
                <mat-icon>swap_vert</mat-icon>
                <span>Reorder Children</span>
            </button>
        </mat-menu>
        -->

        <!-- Header-strip posts (head/deputy/assistant) rendered INSIDE the coloured division header band -->
        <ng-container *ngIf="node.data?.headerPostsInParent?.length">
            <ng-container *ngTemplateOutlet="headerStripTpl; context: { $implicit: node }"></ng-container>
        </ng-container>

        <!-- {{ node.data | json }} -->
    </div>

    <!-- Card content section: flex:1 fills remaining space after .above-card header.
       ⚠️ CRITICAL: cdkDropListGroup MUST use <ng-container> (no DOM element), NOT <div>.
       The height chain requires shared-org-board-node to be a DIRECT child of <section>
       so its host-element height:100% resolves against the flexed section height.
       A <div> wrapper would break this — the component's height:100% would resolve
       against the div's auto height instead. See organization-board.component.scss
       and updateNodeDimensions() in the .ts file for the full height system docs. -->
    <section (contextmenu)="onRightClickNode($event, node); $event.stopPropagation()">
        <ng-container cdkDropListGroup>
            <shared-org-board-node
                [userDisplayMode]="determineLayout(node.data.userDetailsArray)"
                [data]="userDropDataMap[node.id]"
                [dropLists]="dropLists"
                [isDragNavDisabled]="isDragNavDisabled"
                [isEditing]="isEditing"
                [isVfpEditingOn]="isVfpEditingOn"
                [hideStaff]="hideStaffOnBoard"
                [deletingPartKeys]="deletingPartKeysSet"
                [processingUserKeys]="processingUserKeysSet"
                [isDroppableItemBeingDragged]="isDroppableItemBeingDragged"
                [isNavigatingWithDrag]="isNavigatingWithDrag"
                [node]="node"
                [org]="organization"
                (dragEnded)="stopInterval(); onDragItemEnd()"
                (dragStarted)="onDragItemStart($event)"
                (dropList)="updateDropList(node, $event)"
                (openUser)="onOpenUser($event)"
                (openTemplate)="sidebarService.openTemplate(getSidebarTemplateForNode(node), $event)"
                (selectSiblingNode)="selectSiblingNodes($event)"
                (stateChange)="stateChange($event)"
                (templateDrop)="onDrop($event.event, $event.node)"
                (editSection)="onEditSection($event)"
                (addSiblingSection)="onAddSiblingSection($event)"
                (addChildUnit)="onAddChildUnit($event)"
                (deleteSection)="onDeleteSection($event)"
                (editUnit)="onEditUnit($event)"
                (addSiblingUnit)="onAddSiblingUnit($event)"
                (addChildPost)="onAddChildPost($event)"
                (deleteUnit)="onDeleteUnit($event)"
                (addSiblingPost)="onAddSiblingPost($event)"
                (editPost)="onEditPost($event)"
                (deletePost)="onDeletePost($event)"
                (reorderSectionChildren)="onReorderSectionChildren($event)"
                (reorderUnitChildren)="onReorderUnitChildren($event)"
                (bulkAssignStaff)="onBulkAssignStaffFromPart($event)"
                (removeUserFromPosition)="onRemoveUserFromPosition($event)"
                (openPositionTemplate)="onOpenPositionTemplate($event)"
                (openUserTemplate)="onOpenUserTemplate($event)"
                (navigateToHfaOrigin)="onNavigateToHfaOrigin($event, node)"
                (vfpChanged)="onVfpChanged($event)"
                (vfpAlwaysVisibleChanged)="onVfpAlwaysVisibleChanged($event)"
                (approveUser)="onApproveUser($event)"
            ></shared-org-board-node>
        </ng-container>
    </section>
</ng-template>

<ng-template #sideBarOneUserTemplate let-data>
    <div [@slideInOut] class="side-bar-content">
        <shared-sidebar-user
            [node]="data.data"
            [user]="data.data.data.userDetailsArray[0]"
            [org]="organization"
            class="flex-1-auto w-100"
        ></shared-sidebar-user>

        <!-- Position Details -->
        <shared-sidebar-position-detail
            [node]="data?.data"
            [isEditing]="isEditing"
            [isDev]="isDev"
            [org]="organization"
            class="flex-1-auto w-100"
        ></shared-sidebar-position-detail>
    </div>
</ng-template>

<ng-template #sideBarManyUserTemplate let-data>
    <div
        [@slideInOut]
        class="side-bar-content"
        *ngFor="let user of data?.data?.data.userDetailsArray; first as isFirst"
        [ngClass]="{ 'top-divider': data?.data?.data.userDetailsArray.length > 1 && !isFirst }"
    >
        <shared-sidebar-user
            [org]="organization"
            [node]="data?.data"
            [user]="user"
            class="flex-1-auto w-100"
        ></shared-sidebar-user>
    </div>

    <!-- Position Details -->
    <div [@slideInOut] class="side-bar-content">
        <shared-sidebar-position-detail
            [org]="organization"
            [node]="data?.data"
            [isEditing]="isEditing"
            [isDev]="isDev"
            class="flex-1-auto w-100"
        ></shared-sidebar-position-detail>
    </div>
</ng-template>

<ng-template #sideBarEmptyUserTemplate let-data>
    <div [@slideInOut] class="side-bar-content">
        <shared-sidebar-empty-user
            [org]="organization"
            [node]="data.data"
            [isEditing]="isEditing"
            [isDev]="isDev"
            class="flex-1-auto w-100"
        ></shared-sidebar-empty-user>

        <!-- Position Details -->
        <shared-sidebar-position-detail
            [node]="data.data"
            [isEditing]="isEditing"
            [isDev]="isDev"
            class="flex-1-auto w-100"
        ></shared-sidebar-position-detail>
    </div>

    <!-- <div style="background-color: #909090; display: flex; height: 100%; width: 100%; flex: 1 auto;"></div> -->
</ng-template>

<ng-template #sideBarPositionTemplate let-data>
    <div [@slideInOut] class="side-bar-content">
        <shared-sidebar-position
            [node]="data.data"
            [org]="organization"
            [isEditing]="isEditing"
            [isDev]="isDev"
            (navigateToHfaOrigin)="onNavigateToHfaOrigin($event, data.data)"
            class="flex-1-auto w-100"
        ></shared-sidebar-position>
    </div>
</ng-template>

<ng-template #sideBarUserTemplate let-data>
    <div [@slideInOut] class="side-bar-content">
        <shared-sidebar-user
            [node]="data.data.node"
            [user]="data.data.user"
            [org]="organization"
            [userKey]="data.data.user?.uid || data.data.user?.key"
            [isHFA]="data.data.isHFA"
            class="flex-1-auto w-100"
        ></shared-sidebar-user>
    </div>
</ng-template>

<!-- ════════════════════════════════════════════════════════════════════════════
     Header-Strip Template — Renders head/deputy/assistant posts INSIDE the
     coloured card title bar (.above-card / .above-card2). Each chip shows the
     assigned user's avatar + name (or "Unoccupied"), the role badge, and the
     post name. Click opens the post detail sidebar.
     ════════════════════════════════════════════════════════════════════════════ -->
<ng-template #headerStripTpl let-node>
    <!-- Stack chips vertically and let each chip span the full width of the
       card. Equal left/right padding keeps chips visually centred regardless
       of the absolutely-positioned 3-dot menu (org-header-menu-btn) which
       overlaps but does not push the chips. -->
    <!-- Drops on the title strip land OUTSIDE every CDK container (the node
       user-dropzones live in the card body) — they are handled by the user
       pool's FALLBACK path (onUserPoolDragEnd → elementFromPoint → the
       droppable-part attrs on the chips below). -->
    <div
        class="ob-header-posts-strip"
        (click)="$event.stopPropagation()"
        style="
            display: flex;
            flex-direction: column;
            gap: 6px;
            align-items: stretch;
            padding: 6px 10px 0 10px;
            margin-top: 6px;
        "
    >
        <ng-container *ngFor="let hp of node.data.headerPostsInParent">
            <!-- droppable-part + the FULL attr set (key/type/name/parent-dept-key):
           the onDrop DOM walk requires all four, so staff can be dragged from
           the Open Staff Pool onto head/deputy/assistant posts (ISS-001). -->
            <span
                class="ob-header-post-chip clickable-span droppable-part"
                [attr.data-part-key]="hp?.partKey || hp?.key"
                [attr.data-part-type]="'post'"
                [attr.data-part-name]="hp?.name"
                [attr.data-parent-dept-key]="node?.data?.key"
                [attr.data-header-role]="hp?.headerRole"
                (click)="onOpenPositionTemplate({ data: hp, parentNode: node }); $event.stopPropagation()"
                style="
                    position: relative;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 6px 10px 6px 6px;
                    border-radius: 14px;
                    background: rgba(255, 255, 255, 0.95);
                    color: #222;
                    border: 1px solid rgba(0, 0, 0, 0.12);
                    line-height: 1.3;
                    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
                    cursor: pointer;
                    width: 100%;
                    box-sizing: border-box;
                "
            >
                <ng-container *ngIf="getHeaderPostUser(hp) as hpUser; else noHpUser">
                    <!-- Avatar with online indicator (top-right, matches .ob-online-dot pattern) -->
                    <span
                        class="ob-staff"
                        style="position: relative; flex-shrink: 0"
                        [style.width.px]="hpUser?.isHFA ? 28 : 52"
                        [style.height.px]="hpUser?.isHFA ? 28 : 52"
                    >
                        <img
                            [src]="getUserAvatarUrl(hpUser)"
                            alt=""
                            style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover; display: block"
                        />
                        <span
                            *ngIf="isHeaderUserOnline(hpUser)"
                            title="Online"
                            style="
                                position: absolute;
                                top: -3px;
                                right: -3px;
                                width: 14px;
                                height: 14px;
                                border-radius: 50%;
                                background-color: #2ecc71;
                                border: 2px solid white;
                                pointer-events: none;
                            "
                        ></span>
                    </span>
                    <span
                        style="display: flex; flex-direction: column; min-width: 0; flex: 1; text-align: left; gap: 2px"
                        [style.padding-right.px]="isEditing ? 38 : 0"
                    >
                        <!-- Role tag and post name share one line, so the chip stays two lines
                 tall and the person's name reads largest (wall-TV pass, Nov 2026). -->
                        <span
                            class="ob-chip-post-line"
                            style="display: flex; align-items: center; flex-wrap: wrap; gap: 2px 6px; line-height: 1.25"
                        >
                            <!-- Role tag: small, subtle, single short word like HEAD/DEPUTY -->
                            <span
                                style="
                                    display: inline-block;
                                    flex: 0 0 auto;
                                    text-transform: uppercase;
                                    font-size: 14px;
                                    font-weight: 700;
                                    letter-spacing: 0.6px;
                                    color: #fff;
                                    background: #4a5568;
                                    padding: 1px 7px;
                                    border-radius: 4px;
                                    line-height: 1.4;
                                "
                            >
                                {{ hp?.headerRole }}
                            </span>
                            <!-- Post name: prominent title, normal case, wraps cleanly -->
                            <span
                                style="
                                    font-size: 24px;
                                    font-weight: 700;
                                    color: #333;
                                    word-break: break-word;
                                    overflow-wrap: anywhere;
                                "
                            >
                                {{ hp?.name }}
                            </span>
                        </span>
                        <!-- HFA: a link chip to the origin post (the tooltip names the holder), so a
                 person covering many posts is not repeated on each one (Nov 2026).
                 Direct holders render as their name. -->
                        <ng-container *ngIf="hpUser?.isHFA; else directUserName">
                            <span
                                class="ob-hfa-link clickable-span ob-staff"
                                role="link"
                                [matTooltip]="'Held from above by ' + hpUser?.name + ' — click to go to their post'"
                                (click)="
                                    onNavigateToHfaOrigin(hp?.heldFromAbovePartKey, node); $event.stopPropagation()
                                "
                                style="margin-top: 2px; align-self: flex-start"
                                ><mat-icon>link</mat-icon>HFA</span
                            >
                        </ng-container>
                        <ng-template #directUserName>
                            <span
                                class="ob-staff"
                                style="margin-top: 2px; font-weight: 500; font-size: 24px; color: #111"
                            >
                                {{ hpUser?.name }}
                            </span>
                        </ng-template>
                        <!-- ISS-005: header posts never showed their VFP — reuse the
                 standard .sub-part-vfp reveal (chip hover, per-part pin, or
                 the board-level Show VFPs toggle). -->
                        <span
                            *ngIf="hp?.vfp"
                            class="sub-part-vfp"
                            [class.vfp-pinned]="hp?.vfpAlwaysVisible"
                            style="
                                font-size: 13px;
                                line-height: 1.35;
                                color: #444;
                                white-space: pre-wrap;
                                word-break: break-word;
                                text-align: left;
                            "
                        >
                            <strong>VFP:</strong> {{ hp.vfp }}
                        </span>
                        <!-- ISS-008: a header post can carry MORE than one assigned user
                 (the backend doesn't forbid it). The board used to render
                 only the first, silently hiding double assignments — surface
                 every occupant with an amber flag so mistakes are visible. -->
                        <ng-container *ngIf="getHeaderPostUsers(hp) as hpUsers">
                            <span
                                *ngIf="hpUsers.length > 1"
                                class="ob-staff"
                                matTooltip="Multiple people are assigned to this header post — usually a mistake for head roles"
                                style="
                                    margin-top: 4px;
                                    display: inline-flex;
                                    flex-wrap: wrap;
                                    align-items: center;
                                    gap: 4px;
                                    align-self: flex-start;
                                    background: #fff3e0;
                                    border: 1px solid #f0ad4e;
                                    color: #8a5a00;
                                    border-radius: 8px;
                                    padding: 2px 8px;
                                    font-size: 12px;
                                    font-weight: 600;
                                "
                            >
                                ⚠ {{ hpUsers.length }} assigned:
                                <span *ngFor="let xu of hpUsers; let last = last" style="font-weight: 500"
                                    >{{ xu?.name }}<span *ngIf="!last">,&nbsp;</span></span
                                >
                            </span>
                        </ng-container>
                    </span>
                    <!-- Edit-mode staff actions — the SAME approve/remove pair a body
                         post row carries (org-board-node #postInParentTpl). Header
                         posts had no affordance at all, so a head/deputy/assistant
                         could only be removed via the Hats panel. HFA occupants are
                         not on this post, so nothing to remove. Anchored bottom-right
                         under the POST badge so it never fights the title. -->
                    <span
                        *ngIf="isEditing && !hpUser?.isHFA"
                        class="ob-user-actions ob-header-user-actions ob-staff"
                        (click)="$event.stopPropagation()"
                        style="position: absolute; right: 10px; bottom: 10px"
                    >
                        <button
                            *ngIf="hpUser?.isPending && !hpUser?.awaitingAcceptance"
                            mat-icon-button
                            matTooltip="Approve assignment"
                            style="
                                width: 24px;
                                height: 24px;
                                line-height: 24px;
                                min-width: 24px;
                                padding: 0;
                                background-color: #2e7d32;
                                border-radius: 50%;
                            "
                            (click)="onApproveUser({ user: hpUser, node: node, post: hp }); $event.stopPropagation()"
                        >
                            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white">check</mat-icon>
                        </button>
                        <button
                            mat-icon-button
                            matTooltip="Remove staff member from post"
                            style="
                                width: 24px;
                                height: 24px;
                                line-height: 24px;
                                min-width: 24px;
                                padding: 0;
                                background-color: #c62828;
                                border-radius: 50%;
                            "
                            (click)="onRemoveHeaderPostUser(hpUser, hp); $event.stopPropagation()"
                        >
                            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white">{{
                                hpUser?.isPending ? 'close' : 'remove'
                            }}</mat-icon>
                        </button>
                    </span>
                </ng-container>
                <ng-template #noHpUser>
                    <span
                        class="ob-staff"
                        style="
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            width: 36px;
                            height: 36px;
                            border-radius: 50%;
                            background: rgba(0, 0, 0, 0.1);
                            color: rgba(0, 0, 0, 0.4);
                            font-size: 15px;
                            flex-shrink: 0;
                        "
                        >—</span
                    >
                    <span
                        style="display: flex; flex-direction: column; min-width: 0; flex: 1; text-align: left; gap: 2px"
                        [style.padding-right.px]="isEditing ? 38 : 0"
                    >
                        <!-- Role tag and post name share one line, so the chip stays two lines
                 tall and the person's name reads largest (wall-TV pass, Nov 2026). -->
                        <span
                            class="ob-chip-post-line"
                            style="display: flex; align-items: center; flex-wrap: wrap; gap: 2px 6px; line-height: 1.25"
                        >
                            <span
                                style="
                                    display: inline-block;
                                    flex: 0 0 auto;
                                    text-transform: uppercase;
                                    font-size: 12px;
                                    font-weight: 700;
                                    letter-spacing: 0.6px;
                                    color: #fff;
                                    background: #4a5568;
                                    padding: 1px 7px;
                                    border-radius: 4px;
                                    line-height: 1.4;
                                "
                            >
                                {{ hp?.headerRole }}
                            </span>
                            <span
                                style="
                                    font-size: 15px;
                                    font-weight: 600;
                                    color: #333;
                                    word-break: break-word;
                                    overflow-wrap: anywhere;
                                "
                            >
                                {{ hp?.name }}
                            </span>
                        </span>
                        <span
                            class="ob-staff"
                            style="margin-top: 2px; font-style: italic; font-weight: 500; font-size: 16px; color: #888"
                            >Unoccupied</span
                        >
                    </span>
                </ng-template>
            </span>
        </ng-container>
    </div>
</ng-template>

<!-- Board of Directors (detached box) menu: its seats live in the CEO's
     container, so both actions open that container's editor. -->
<mat-menu #detachedBoxMenu="matMenu">
    <ng-template matMenuContent let-box="box">
        <button mat-menu-item (click)="onEditDetachedBox(box)">
            <mat-icon>edit</mat-icon>
            <span>Edit Board of Directors</span>
        </button>
        <button mat-menu-item (click)="onAddBoardSeat(box)">
            <mat-icon color="accent">add_circle</mat-icon>
            <span>Add board seat</span>
        </button>
    </ng-template>
</mat-menu>
